'use client';

import { useBreakpointValue } from '@ironhack/design-system2/hooks';
import { type BoxProps } from '@ironhack/design-system2/components/box';
import { type ReactElement } from 'react';

import { createStructuredContent } from '@/lib/datocms/structured-text';
import { type DatoImage, type DatoModuleFormat } from '@/lib/datocms';
import { InfoMedia } from '@/app/components/server/info-media';

export type Awards = {
  image: DatoImage;
  subtitle: string;
  title: string;
};

type Props = { data: Awards } & BoxProps;

export const Awards = (props: Props): ReactElement => {
  const {
    data: { image, subtitle, title },
    ...boxProps
  } = props;

  const mediaSide = useBreakpointValue<'left' | 'right'>({
    base: 'right',
    md: 'left',
  });

  const infoMediaData = {
    content: createStructuredContent(subtitle),
    headingProps: { as: 'h2' as const, textStyle: ['5xl', null, '2xl'] },
    image,
    mediaSide,
    moduleFormat: [
      {
        background: 'light',
        spacingBottom: ['32', null, '40'],
        spacingTop: ['32', null, '40'],
      },
    ] as [DatoModuleFormat],
    title,
  };
  return <InfoMedia as="section" data={infoMediaData} {...boxProps} />;
};
